import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import { HasProduct, withProduct } from "@insite/client-framework/Components/ProductContext";
import siteMessage from "@insite/client-framework/SiteMessage";
import ApplicationState from "@insite/client-framework/Store/ApplicationState";
import { getSettingsCollection } from "@insite/client-framework/Store/Context/ContextSelectors";
import { getLocation } from "@insite/client-framework/Store/Data/Pages/PageSelectors";
import { getPageLinkByPageType } from "@insite/client-framework/Store/Links/LinksSelectors";
import translate from "@insite/client-framework/Translate";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import WidgetProps from "@insite/client-framework/Types/WidgetProps";
import Button, { ButtonPresentationProps } from "@insite/mobius/Button";
import Link from "@insite/mobius/Link/Link";
import Modal, { ModalPresentationProps } from "@insite/mobius/Modal";
import Typography, { TypographyProps } from "@insite/mobius/Typography";
import getColor from "@insite/mobius/utilities/getColor";
import { useHistory } from "@insite/mobius/utilities/HistoryContext";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import GetQuoteForProduct from "@tSurya/Components/GetQuoteForProduct";
import ProductAddToCartButton from "@tSurya/Components/ProductAddToCartButton";
import Constant from "@tSurya/Constants/Constant";
import { COLORS, TYPOGRAPHY } from "@tSurya/theme/design";
import * as React from "react";
import { connect } from "react-redux";
import { css } from "styled-components";

type Props = WidgetProps & HasProduct & ReturnType<typeof mapStateToProps>;

const mapStateToProps = (state: ApplicationState, ownProps: HasProduct) => ({
    configurationSelection: state.pages.productDetails.configurationSelection,
    configurationCompleted: state.pages.productDetails.configurationCompleted,
    variantSelectionCompleted: state.pages.productDetails.variantSelectionCompleted,
    subscription: state.pages.productDetails.subscription,
    isAuthenticated: state.context.session.isAuthenticated,
    isGuest: state.context.session.isGuest,
    productSettings: getSettingsCollection(state).productSettings,
    signInUrl: getPageLinkByPageType(state, "SignInPage")?.url,
    currentLocation: getLocation(state),
    userRole: state.context.session.userRoles,
});

export interface ProductDetailsAddToCartButtonStyles {
    button?: ButtonPresentationProps;
    buttonLink?: ButtonPresentationProps;
    customModal?: ModalPresentationProps;
    innerWrapper?: InjectableCss;
    modal?: ModalPresentationProps;
    SizeMessageText?: TypographyProps;
}

export const addToCartButtonStyles: ProductDetailsAddToCartButtonStyles = {
    // button: {
    //     css: css`
    //         width: 100%;
    //         border-radius: 0;
    //         padding: 10px 40px !important;
    //         display: flex;
    //         justify-content: center;
    //         align-items: center;
    //         background: ${getColor("text.main")};
    //         white-space: nowrap;
    //         span {
    //             font-family: ${TYPOGRAPHY.fontFamily.title};
    //             font-style: normal;
    //             font-weight: ${TYPOGRAPHY.weight.bold};
    //             font-size: ${TYPOGRAPHY.size.base};
    //             line-height: ${TYPOGRAPHY.lineHeight.xbase};
    //             text-align: center;
    //             color: ${getColor("primary.contrast")};
    //         }
    //     `,
    // },
    // buttonLink: {
    //     css: css`
    //         width: 100%;
    //         border-radius: 0;
    //         padding: 10px 40px !important;
    //         display: flex;
    //         justify-content: center;
    //         align-items: center;
    //         background: ${getColor("text.main")};
    //         white-space: nowrap;
    //         span {
    //             font-family: ${TYPOGRAPHY.fontFamily.title};
    //             font-style: normal;
    //             font-weight: ${TYPOGRAPHY.weight.bold};
    //             font-size: ${TYPOGRAPHY.size.base};
    //             line-height: ${TYPOGRAPHY.lineHeight.xbase};
    //             text-align: center;
    //             color: ${getColor("primary.contrast")} !important;
    //         }
    //         &[disabled] {
    //             background: rgb(204, 204, 204);
    //             border-color: rgb(204, 204, 204);
    //             color: rgb(255, 255, 255);
    //             cursor: not-allowed;
    //             pointer-events: none;
    //         }
    //     `,
    // },
    customModal: {
        sizeVariant: "large",
    },
    modal: {
        size: 350,
        cssOverrides: {
            modalBody: css`
                overflow-y: visible;
            `,
            modalTitle: css`
                padding: 10px 20px;
            `,
            modalContent: css`
                padding: 20px;
            `,
        },
    },
};

const styles = addToCartButtonStyles;

const ProductDetailsAddToCartButton = ({
    configurationSelection,
    configurationCompleted,
    variantSelectionCompleted,
    subscription,
    isAuthenticated,
    signInUrl,
    currentLocation,
    product,
    userRole,
}: Props) => {
    const [fullPrimaryImageModalIsOpen, setFullImageModalIsOpen] = React.useState(false);
    const [returnUrl, setReturnUrl] = React.useState(currentLocation.pathname + currentLocation.search);
    const history = useHistory();
    const [modalIsOpen, setModalIsOpen] = React.useState(false);

    React.useEffect(() => {
        setReturnUrl(currentLocation.pathname + currentLocation.search);
    }, [product]);

    const openCustomModal = () => {
        setFullImageModalIsOpen(true);
    };

    const customModalCloseHandler = () => {
        setFullImageModalIsOpen(false);
    };
    const handleProductClick = () => {
        if(variantSelectionCompleted) {
            if (
                (product.productNumber.toLowerCase().endsWith(Constant.customProduct) &&
                    product.properties.productType === "Rug Pad") ||
                !product.productNumber.toLowerCase().endsWith(Constant.customProduct)
            ) {
                history.push(`${signInUrl}?returnUrl=${encodeURIComponent(returnUrl)}&clientRedirect=true`);
            }

        }
        else{ 
            setModalIsOpen(true);
        }
        
    };
    const modalCloseHandler = () => {
        setModalIsOpen(false);
    };
    return (
        <>
            {isAuthenticated &&
            (product.productNumber.toLowerCase().endsWith(Constant.customStandardProduct) ||
                product.productNumber.toLowerCase().endsWith(Constant.customExpiditeProduct) ||
                (product.productNumber.toLowerCase().endsWith(Constant.customProduct) &&
                    product.properties.productType === Constant.customProductType)) &&
            userRole !== "Collaborator" ? (
                <StyledWrapper>
                    <Button variant="primary" role="button" aria-label="Get Quote" onClick={openCustomModal}>
                        Get Quote
                    </Button>
                    <Modal
                        headline={`${
                            product.productNumber.toLowerCase().endsWith(Constant.customProduct)
                                ? "Custom"
                                : product.productNumber.toLowerCase().endsWith(Constant.customStandardProduct)
                                ? "Custom: STANDARD"
                                : "Custom: EXPEDITED"
                        }`}
                        {...styles.customModal}
                        isOpen={fullPrimaryImageModalIsOpen}
                        handleClose={customModalCloseHandler}
                        closeOnScrimClick={false}
                    >
                        <GetQuoteForProduct productData={product} closeHandler={customModalCloseHandler} />
                    </Modal>
                </StyledWrapper>
            ) : isAuthenticated && variantSelectionCompleted && userRole !== "Collaborator" ? (
                <StyledWrapper>
                    <ProductAddToCartButton
                        configurationSelection={configurationSelection}
                        configurationCompleted={configurationCompleted}
                        variantSelectionCompleted={variantSelectionCompleted}
                        subscription={subscription}
                        extendedStyles={styles.button}
                        data-test-selector="addProductToCart"
                    />
                </StyledWrapper>
            ) :  userRole !== "Collaborator" ? (
                <Button
                    variant="primary"
                    onClick={handleProductClick}
                    {...styles.buttonLink}
                    aria-label="add to cart"
                    disabled={
                        !!product.productNumber.toLowerCase().endsWith(Constant.customProduct) &&
                        product.properties.productType !== Constant.customProductType
                    }
                >
                    {product.productNumber.toLowerCase().endsWith(Constant.customStandardProduct) ||
                    product.productNumber.toLowerCase().endsWith(Constant.customExpiditeProduct) ||
                    (product.productNumber.toLowerCase().endsWith(Constant.customProduct) &&
                        product.properties.productType === Constant.customProductType)
                        ? "Get Quote"
                        : "Add to Cart"}
                </Button>
            ) : null}
           { modalIsOpen && <Modal
                {...styles.modal}
                headline={translate("Select Size")}
                isOpen={modalIsOpen}
                handleClose={modalCloseHandler}
              >
                <StyledWrapper {...styles.innerWrapper} data-test-selector="productAddToListModal">
                    <Typography data-test-selector="productAddToListModal_requireSignIn" {...styles.SizeMessageText}>
                            {siteMessage(
                                "List_Must_Select_Size",
                                `${signInUrl}?returnUrl=${encodeURIComponent(returnUrl)}&clientRedirect=true`,
                            )}
                        </Typography>

                </StyledWrapper>
              </Modal>
           }
        </>
    );
};

const widgetModule: WidgetModule = {
    component: withProduct(connect(mapStateToProps)(ProductDetailsAddToCartButton)),
    definition: {
        displayName: "Add to Cart Button",
        group: "Product Details",
        allowedContexts: ["ProductDetailsPage"],
    },
};

export default widgetModule;
